// Liste mondiale des pays avec indicatif téléphonique. Drapeau calculé depuis le code ISO.
const flagOf = (code) =>
  code.toUpperCase().replace(/./g, (c) => String.fromCodePoint(127397 + c.charCodeAt(0)));

const RAW = [
  ["AF", "Afghanistan", "+93"], ["AL", "Albanie", "+355"], ["DZ", "Algérie", "+213"],
  ["AD", "Andorre", "+376"], ["AO", "Angola", "+244"], ["AG", "Antigua-et-Barbuda", "+1268"],
  ["AR", "Argentine", "+54"], ["AM", "Arménie", "+374"], ["AU", "Australie", "+61"],
  ["AT", "Autriche", "+43"], ["AZ", "Azerbaïdjan", "+994"], ["BS", "Bahamas", "+1242"],
  ["BH", "Bahreïn", "+973"], ["BD", "Bangladesh", "+880"], ["BB", "Barbade", "+1246"],
  ["BY", "Biélorussie", "+375"], ["BE", "Belgique", "+32"], ["BZ", "Belize", "+501"],
  ["BJ", "Bénin", "+229"], ["BT", "Bhoutan", "+975"], ["BO", "Bolivie", "+591"],
  ["BA", "Bosnie-Herzégovine", "+387"], ["BW", "Botswana", "+267"], ["BR", "Brésil", "+55"],
  ["BN", "Brunei", "+673"], ["BG", "Bulgarie", "+359"], ["BF", "Burkina Faso", "+226"],
  ["BI", "Burundi", "+257"], ["KH", "Cambodge", "+855"], ["CM", "Cameroun", "+237"],
  ["CA", "Canada", "+1"], ["CV", "Cap-Vert", "+238"], ["CF", "Centrafrique", "+236"],
  ["TD", "Tchad", "+235"], ["CL", "Chili", "+56"], ["CN", "Chine", "+86"],
  ["CO", "Colombie", "+57"], ["KM", "Comores", "+269"], ["CG", "Congo", "+242"],
  ["CD", "Congo (RDC)", "+243"], ["CR", "Costa Rica", "+506"], ["CI", "Côte d'Ivoire", "+225"],
  ["HR", "Croatie", "+385"], ["CU", "Cuba", "+53"], ["CY", "Chypre", "+357"],
  ["CZ", "Tchéquie", "+420"], ["DK", "Danemark", "+45"], ["DJ", "Djibouti", "+253"],
  ["DM", "Dominique", "+1767"], ["DO", "République dominicaine", "+1809"], ["EC", "Équateur", "+593"],
  ["EG", "Égypte", "+20"], ["SV", "Salvador", "+503"], ["GQ", "Guinée équatoriale", "+240"],
  ["ER", "Érythrée", "+291"], ["EE", "Estonie", "+372"], ["SZ", "Eswatini", "+268"],
  ["ET", "Éthiopie", "+251"], ["FJ", "Fidji", "+679"], ["FI", "Finlande", "+358"],
  ["FR", "France", "+33"], ["GA", "Gabon", "+241"], ["GM", "Gambie", "+220"],
  ["GE", "Géorgie", "+995"], ["DE", "Allemagne", "+49"], ["GH", "Ghana", "+233"],
  ["GR", "Grèce", "+30"], ["GD", "Grenade", "+1473"], ["GT", "Guatemala", "+502"],
  ["GN", "Guinée", "+224"], ["GW", "Guinée-Bissau", "+245"], ["GY", "Guyana", "+592"],
  ["HT", "Haïti", "+509"], ["HN", "Honduras", "+504"], ["HK", "Hong Kong", "+852"],
  ["HU", "Hongrie", "+36"], ["IS", "Islande", "+354"], ["IN", "Inde", "+91"],
  ["ID", "Indonésie", "+62"], ["IR", "Iran", "+98"], ["IQ", "Irak", "+964"],
  ["IE", "Irlande", "+353"], ["IL", "Israël", "+972"], ["IT", "Italie", "+39"],
  ["JM", "Jamaïque", "+1876"], ["JP", "Japon", "+81"], ["JO", "Jordanie", "+962"],
  ["KZ", "Kazakhstan", "+7"], ["KE", "Kenya", "+254"], ["KI", "Kiribati", "+686"],
  ["KW", "Koweït", "+965"], ["KG", "Kirghizistan", "+996"], ["LA", "Laos", "+856"],
  ["LV", "Lettonie", "+371"], ["LB", "Liban", "+961"], ["LS", "Lesotho", "+266"],
  ["LR", "Libéria", "+231"], ["LY", "Libye", "+218"], ["LI", "Liechtenstein", "+423"],
  ["LT", "Lituanie", "+370"], ["LU", "Luxembourg", "+352"], ["MO", "Macao", "+853"],
  ["MG", "Madagascar", "+261"], ["MW", "Malawi", "+265"], ["MY", "Malaisie", "+60"],
  ["MV", "Maldives", "+960"], ["ML", "Mali", "+223"], ["MT", "Malte", "+356"],
  ["MH", "Îles Marshall", "+692"], ["MR", "Mauritanie", "+222"], ["MU", "Maurice", "+230"],
  ["MX", "Mexique", "+52"], ["FM", "Micronésie", "+691"], ["MD", "Moldavie", "+373"],
  ["MC", "Monaco", "+377"], ["MN", "Mongolie", "+976"], ["ME", "Monténégro", "+382"],
  ["MA", "Maroc", "+212"], ["MZ", "Mozambique", "+258"], ["MM", "Myanmar", "+95"],
  ["NA", "Namibie", "+264"], ["NR", "Nauru", "+674"], ["NP", "Népal", "+977"],
  ["NL", "Pays-Bas", "+31"], ["NZ", "Nouvelle-Zélande", "+64"], ["NI", "Nicaragua", "+505"],
  ["NE", "Niger", "+227"], ["NG", "Nigéria", "+234"], ["KP", "Corée du Nord", "+850"],
  ["MK", "Macédoine du Nord", "+389"], ["NO", "Norvège", "+47"], ["OM", "Oman", "+968"],
  ["PK", "Pakistan", "+92"], ["PW", "Palaos", "+680"], ["PS", "Palestine", "+970"],
  ["PA", "Panama", "+507"], ["PG", "Papouasie-Nouvelle-Guinée", "+675"], ["PY", "Paraguay", "+595"],
  ["PE", "Pérou", "+51"], ["PH", "Philippines", "+63"], ["PL", "Pologne", "+48"],
  ["PT", "Portugal", "+351"], ["QA", "Qatar", "+974"], ["RO", "Roumanie", "+40"],
  ["RU", "Russie", "+7"], ["RW", "Rwanda", "+250"], ["KN", "Saint-Kitts-et-Nevis", "+1869"],
  ["LC", "Sainte-Lucie", "+1758"], ["VC", "Saint-Vincent-et-les-Grenadines", "+1784"],
  ["WS", "Samoa", "+685"], ["SM", "Saint-Marin", "+378"], ["ST", "Sao Tomé-et-Principe", "+239"],
  ["SA", "Arabie saoudite", "+966"], ["SN", "Sénégal", "+221"], ["RS", "Serbie", "+381"],
  ["SC", "Seychelles", "+248"], ["SL", "Sierra Leone", "+232"], ["SG", "Singapour", "+65"],
  ["SK", "Slovaquie", "+421"], ["SI", "Slovénie", "+386"], ["SB", "Îles Salomon", "+677"],
  ["SO", "Somalie", "+252"], ["ZA", "Afrique du Sud", "+27"], ["KR", "Corée du Sud", "+82"],
  ["SS", "Soudan du Sud", "+211"], ["ES", "Espagne", "+34"], ["LK", "Sri Lanka", "+94"],
  ["SD", "Soudan", "+249"], ["SR", "Suriname", "+597"], ["SE", "Suède", "+46"],
  ["CH", "Suisse", "+41"], ["SY", "Syrie", "+963"], ["TW", "Taïwan", "+886"],
  ["TJ", "Tadjikistan", "+992"], ["TZ", "Tanzanie", "+255"], ["TH", "Thaïlande", "+66"],
  ["TL", "Timor oriental", "+670"], ["TG", "Togo", "+228"], ["TO", "Tonga", "+676"],
  ["TT", "Trinité-et-Tobago", "+1868"], ["TN", "Tunisie", "+216"], ["TR", "Turquie", "+90"],
  ["TM", "Turkménistan", "+993"], ["TV", "Tuvalu", "+688"], ["UG", "Ouganda", "+256"],
  ["UA", "Ukraine", "+380"], ["AE", "Émirats arabes unis", "+971"], ["GB", "Royaume-Uni", "+44"],
  ["US", "États-Unis", "+1"], ["UY", "Uruguay", "+598"], ["UZ", "Ouzbékistan", "+998"],
  ["VU", "Vanuatu", "+678"], ["VA", "Vatican", "+379"], ["VE", "Venezuela", "+58"],
  ["VN", "Vietnam", "+84"], ["YE", "Yémen", "+967"], ["ZM", "Zambie", "+260"],
  ["ZW", "Zimbabwe", "+263"],
];

export const COUNTRIES = RAW.map(([code, name, dial]) => ({
  code, name, dial, flag: flagOf(code),
})).sort((a, b) => a.name.localeCompare(b.name, "fr"));

export const findByDial = (dial) => COUNTRIES.find((c) => c.dial === dial);
